module.exports = __webpack_public_path__ + "static/media/road-E-photo.7e44193a.svg";